import { darken as polishedDarken, lighten as polishedLighten, rgba as polishedRgba } from 'polished';

export function darken(amount: number, color: string): string {
  return color === 'auto' ? color : color === 'transparent' ? darken(amount, 'white') : polishedDarken(amount, color);
}

export function lighten(amount: number, color: string): string {
  return color === 'auto' ? color : color === 'transparent' ? color : polishedLighten(amount, color);
}

export function rgba(color: string, amount: number): string {
  return color === 'transparent' ? color : polishedRgba(color, amount);
}
